import { TextareaHTMLAttributes, forwardRef } from 'react';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
	label?: string;
	error?: string;
	helperText?: string;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
	({ label, error, helperText, className = '', ...props }, ref) => {
		return (
			<div className="w-full">
				{label && (
					<label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
						{label}
						{props.required && <span className="text-red-500 ml-1">*</span>}
					</label>
				)}
				<textarea
					ref={ref}
					className={`w-full px-3 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 transition-all resize-vertical min-h-[100px]
            focus:outline-none focus:border-blue-600 focus:ring-3 focus:ring-blue-100 dark:focus:ring-blue-900
            disabled:bg-gray-100 dark:disabled:bg-gray-800 disabled:cursor-not-allowed
            ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-100 dark:focus:ring-red-900' : ''}
            ${className}`}
					{...props}
				/>
				{error && (
					<span className="form-error text-red-500 text-xs mt-1 block">{error}</span>
				)}
				{helperText && !error && (
					<span className="text-xs text-gray-500 dark:text-gray-400 mt-1 block">
						{helperText}
					</span>
				)}
			</div>
		);
	}
);

Textarea.displayName = 'Textarea';

export default Textarea;
